import { getLoginInfo } from "../auth/getLoginInfo";
import { createAxios, createAxiosWithToken } from "./createAxios";

export async function GetAll() {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).get("/DoctorsFastNote/GetAll")
}
export async function GetById(param) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).get("/DoctorsFastNote/GetById?Id=" + param.Id)
}
export async function Add(param) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).post("/DoctorsFastNote/Add", param)
}
export async function Edit(param) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).post("/DoctorsFastNote/Edit", param)
}
export async function Remove(id) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).post("/DoctorsFastNote/Remove?Id=" + id)
}